import { setEventOrder } from './setEventOrder.js';
import { couponTest } from '../coupons/couponTest.js';
import { eventData } from '../helper/EventData.js';

/**
 * Erstelle und aktualisiere die Bestellung basierend auf dem Event und Coupon-Test.
 *
 * @param {string} privatApiKey - API-Schlüssel für den Coupon-Test.
 * @param {string} eventBucketId - Event-Bucket-ID.
 * @param {Object} userData - Benutzerdaten, falls vorhanden.
 * @param {Pass | {}} eventPass - The pass id.
 * @returns {Promise<Order>} - Die erstellte und aktualisierte Bestellung.
 */
export async function createAndUpdateOrder(privatApiKey, eventBucketId, userData = {}, eventPass = {}) {
  let order = null;
  let couponCode = '';
  const eventDataPayload = eventData.get();
  try {
    // Get the voucher code from the input field (if available).
    const couponInputField = document.getElementById(`gd__checkout__discountCode__input`);
    couponCode = couponInputField?.value || '';

    // Step 1: Create the order without a coupon.
    order = await setEventOrder(eventDataPayload, '', userData, {}, eventPass);
    // console.trace('Order without a coupon', order);

    // Step 2: Run the coupon test.
    const couponResult = await couponTest(eventDataPayload, order, privatApiKey, eventBucketId, couponCode, userData);

    // Step 3: If there is a valid coupon, recalculate order.
    if (couponResult && Object.keys(couponResult).length > 0 && couponResult.is_applicable) {
      // console.trace('createAndUpdateOrder couponResult', couponResult);
      order = await setEventOrder(eventDataPayload, couponCode, userData, couponResult, eventPass);
      // console.trace('createAndUpdateOrder order', order);
    }
    return order;

  } catch (error) {
    console.error('Fehler bei der Erstellung der Bestellung:', error);
    throw new Error('Fehler bei der Erstellung der Bestellung');
  }
}
